import {ref} from "vue";

export const products = ref([
    {
        name: "Camotec st lite",
        price: "199.99 грн",
        describe: "sdasdasd",
        imgSrc: require("./assets/img-catalog/male-ing/krosivki-camotec-st-lite-7085-41-1-400x500.png"),
        gender:"male"
    },
    {
        name: "Coordinator",
        price: "199.99 грн",
        describe: "sdasdasd",
        imgSrc: require("./assets/img-catalog/male-ing/krosivki-coordinator-black-2059-1-400x500.png"),
        gender:"male"
    },
    {
        name: "Hermes-coyote",
        price: "199.99 грн",
        imgSrc: require("./assets/img-catalog/male-ing/krosivki-hermes-coyote-6558-7-400x500.png"),
        description: "Опис товару 1",
        gender:"male"
    },
    {
        name: "Black-diamond",
        price: "199.99 грн",
        imgSrc: require("./assets/img-catalog/male-ing/black-diamond-m-mission-xp-lth-krosivki-cholovichi-bd-58002430491101-4-400x500.png"),
        description: "Опис товару 1",
        gender:"male"
    },{
        name: "Cmp-atik",
        price: "199.99 грн",
        imgSrc: require("./assets/img-catalog/male-ing/krosivki-cmp-atik-wp-trail-running-shoes-3q31147-42up-6-400x500.jpg"),
        description: "Опис товару 1",
        gender:"male"
    },{
        name: "Saucony-jazz",
        price: "199.99 грн",
        imgSrc: require("./assets/img-catalog/male-ing/krosivki-saucony-jazz-triple-stonewash-s60768-1-2-400x500.png"),
        description: "Опис товару 1",
        gender:"male"
    },{
        name: "Coordinator-black",
        price: "199.99 грн",
        imgSrc: require("./assets/img-catalog/male-ing/krosivki-coordinator-black-2059-1-400x500.png"),
        description: "Опис товару 1",
        gender:"male"
    },
    {
        name: "Altra-lone",
        price: "199.99 грн",
        imgSrc: require("./assets/img-catalog/male-ing/altra-lone-pe-41-1-400x500.png"),
        description: "Опис товару 1",
        gender:"male"
    },
    {
        name: "Camotec st lite",
        price: "199.99 грн",
        describe: "sdasdasd",
        imgSrc: require("./assets/img-catalog/male-ing/krosivki-camotec-st-lite-7085-41-1-400x500.png"),
        gender:"male"
    },
    {
        name: "Coordinator",
        price: "199.99 грн",
        describe: "sdasdasd",
        imgSrc: require("./assets/img-catalog/male-ing/krosivki-coordinator-black-2059-1-400x500.png"),
        gender:"male"
    },
    {
        name: "Hermes-coyote",
        price: "199.99 грн",
        imgSrc: require("./assets/img-catalog/male-ing/krosivki-hermes-coyote-6558-7-400x500.png"),
        description: "Опис товару 1",
        gender:"male"
    },
    {
        name: "Black-diamond",
        price: "199.99 грн",
        imgSrc: require("./assets/img-catalog/male-ing/black-diamond-m-mission-xp-lth-krosivki-cholovichi-bd-58002430491101-4-400x500.png"),
        description: "Опис товару 1",
        gender:"male"
    },{
        name: "Cmp-atik",
        price: "199.99 грн",
        imgSrc: require("./assets/img-catalog/male-ing/krosivki-cmp-atik-wp-trail-running-shoes-3q31147-42up-6-400x500.jpg"),
        description: "Опис товару 1",
        gender:"male"
    },{
        name: "Saucony-jazz",
        price: "199.99 грн",
        imgSrc: require("./assets/img-catalog/male-ing/krosivki-saucony-jazz-triple-stonewash-s60768-1-2-400x500.png"),
        description: "Опис товару 1",
        gender:"male"
    },{
        name: "Coordinator-black",
        price: "199.99 грн",
        imgSrc: require("./assets/img-catalog/male-ing/krosivki-coordinator-black-2059-1-400x500.png"),
        description: "Опис товару 1",
        gender:"male"
    },
    {
        name: "Altra-lone",
        price: "199.99 грн",
        imgSrc: require("./assets/img-catalog/male-ing/altra-lone-pe-41-1-400x500.png"),
        description: "Опис товару 1",
        gender:"female"
    },

]);
